export default __webpack_public_path__ + "static/media/horizontalIcon.fd9ca054.svg";